import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=1c3dbafc&scoped=true&"
import script from "./statistics.vue?vue&type=script&lang=js&"
export * from "./statistics.vue?vue&type=script&lang=js&"
import style0 from "./statistics.vue?vue&type=style&index=0&id=1c3dbafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3dbafc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3dbafc')) {
      api.createRecord('1c3dbafc', component.options)
    } else {
      api.reload('1c3dbafc', component.options)
    }
    module.hot.accept("./statistics.vue?vue&type=template&id=1c3dbafc&scoped=true&", function () {
      api.rerender('1c3dbafc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/incoming/statistics.vue"
export default component.exports